import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "alertCardWrapper" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "leftContent" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  role: "heading",
  "aria-level": "3",
  "aria-label": "alert text"
}

import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertCard',
  props: {
    text: {},
    isWarning: { type: Boolean },
    onClick: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(['alertCard', { warning: _ctx.isWarning, info: !_ctx.isWarning }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Icon), {
            class: "alertIcon",
            "icon-name": _ctx.isWarning ? 'warning' : 'blueInfo'
          }, null, 8, ["icon-name"]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.text)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.text), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_unref(Icon), {
          class: "arrow",
          "icon-name": _ctx.isWarning ? 'redChevron' : 'chevronDown'
        }, null, 8, ["icon-name"])
      ])
    ], 2)
  ]))
}
}

})